<template>
  <div>
    <div class="sub-title my-3">수행 평가</div>
    <div>
      <folder-label label="NCS 교과" :open="true">
        <mdb-row class="underline bolder my-3 blue lighten-5">
          <mdb-col md="6">과목/능력단위</mdb-col>
          <mdb-col md="3" class="text-right">1차 과제</mdb-col>
          <mdb-col md="3" class="text-right">2차 과제</mdb-col>
        </mdb-row>
        <div v-for="(s, i) in subjects.NCS" :key="i">
          <div class="title my-3"><mdb-icon icon="chalkboard-teacher" /> {{s.name}}</div>
          <mdb-row class="ml-3 underline" v-for="(l, i) in s.lectures" :key="i">
            <mdb-col md="6"  class="" :class="{'red-text': isRetry(l.code)}"><mdb-icon icon="chalkboard" /> {{l.name}}</mdb-col>
            <mdb-col md="3" class="text-right">
              <perform-test-status v-if="answers.seq1" :test="tests[l.code]" :answer="answers.seq1[l.code]" :seq="1"/>
            </mdb-col>
            <mdb-col md="3" class="text-right" v-if="isRetry(l.code)">
              <perform-test-status v-if="answers.seq2" :test="tests[l.code]" :answer="answers.seq2[l.code]" :seq="2"/>
            </mdb-col>
          </mdb-row>
        </div>
      </folder-label>
      <br>
      <folder-label label="비 NCS 교과" :open="true">
        <mdb-row class="underline bolder my-3 blue lighten-5">
          <mdb-col md="6">과목명</mdb-col>
          <mdb-col md="3" class="text-right">1차 과제</mdb-col>
          <mdb-col md="3" class="text-right">2차 과제</mdb-col>
        </mdb-row>
        <mdb-row v-for="(s, i) in subjects.NONNCS" :key="i" class="my-1 underline">
          <mdb-col md="6"  class="title" :class="{'red-text': isRetry(s.name)}"><mdb-icon icon="chalkboard-teacher" /> {{s.name}}</mdb-col>
          <!-- 1차 평가 -->
          <mdb-col md="3" class="text-right">
            <perform-test-status v-if="answers.seq1" :test="tests[s.name]" :answer="answers.seq1[s.name]" :seq="1"/>
          </mdb-col>
          <!-- 2차 평가 -->
          <mdb-col md="3" class="text-right">
            <perform-test-status v-if="answers.seq2" :test="tests[s.name]" :answer="answers.seq2[s.name]" :seq="2"/>
          </mdb-col>
          <!-- 2차 평가 -->
        </mdb-row>
      </folder-label>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import FolderLabel from '@/components/common/FolderLabel.vue';
import PerformTestStatus from '@/components/test/perform/PerformTestStatus.vue';
export default {
  components: { FolderLabel, PerformTestStatus },
  name: 'StudentPerformTest',
  props: ['training'],
  data: () => ({
    lecture: {},
    tests: {},
    task: {},
    answers: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('subject', ['subjects']),
    ...mapGetters('auth', ['failScore'])
  },
  methods: {
    async load () {
      if (this.profile.training) {
        this.tests = await this.$getPerformTestList(this.profile.training._id)
        this.answers = await this.$getPerformTestAnswerList(this.profile._id)
      }
    },
    isRetry (code) {
      const score = this.answers.seq1 && this.answers.seq1[code] && this.answers.seq1[code].score
      return score ? score < this.failScore : false
    }
  },
  created () {
    this.load()
  },
  watch: {
    profile () {
      this.load()
    }
  }
}
</script>
<style scoped>
.red-text {
  font-weight: 900;
}
</style>
